import { Dropdown } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { selectedMetadataAtom } from '../../atoms/selectedMetadata';
import { getCameraAngleFromTrack } from '../../utils/track';

export function Track({ size }) {
  const intl = useIntl();

  const [selectedMetadata, setSelectedMetadata] = useAtom(selectedMetadataAtom);

  const options = Object.entries(getCameraAngleFromTrack(intl)).map(
    ([key, value]) => ({
      label: value,
      value: key,
    }),
  );

  return (
    <Dropdown
      id="track-select"
      label={intl.formatMessage({ defaultMessage: 'Track', id: '92ea7' })}
      labelPosition="top"
      onChange={(selectedOption) =>
        setSelectedMetadata({
          ...selectedMetadata,
          track: selectedOption.value,
        })
      }
      options={options}
      placeholder={intl.formatMessage({
        defaultMessage: 'Track',
        id: '92ea7',
      })}
      size={size}
      value={options.find(
        (option) => option.value === selectedMetadata.track?.toString(),
      )}
      variant="secondary"
    />
  );
}

Track.propTypes = {
  size: PropTypes.string,
};
Track.defaultProps = {
  size: undefined,
};

export default { Track };
